export default __webpack_public_path__ + "static/media/share.f3bcbc33.svg";